/* esR · feste Kaufleiste am unteren Rand der Produktseite (21.08.2026)
   Wird nur auf Produktseiten geladen (siehe snippets/meta-tags.liquid).
   Styles: assets/esr-fixes.css                                          */
(function () {
  function init() {
    var submit = document.querySelector('.product-form__submit');
    if (!submit || document.querySelector('.esr-buybar')) return;

    var titleEl = document.querySelector('.product__title h1') || document.querySelector('.product__title');
    var name = titleEl ? titleEl.textContent.trim() : document.title.split('–')[0].trim();

    var bar = document.createElement('div');
    bar.className = 'esr-buybar';
    bar.innerHTML =
      '<div class="esr-buybar__row">' +
        '<button type="button" class="esr-buybar__details" aria-label="Paket-Details">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M9 15l2 2 4-4"/></svg>' +
          '<span>Paket-Details</span>' +
        '</button>' +
        '<div class="esr-buybar__name"></div>' +
        '<div class="esr-buybar__right">' +
          '<span class="esr-buybar__total">Preis<b></b></span>' +
          '<button type="button" class="esr-buybar__cta">In den Warenkorb</button>' +
        '</div>' +
      '</div>' +
      '<p class="esr-buybar__note">Vor dem Kauf bitte prüfen: Dein Handy ist <a href="/pages/hilfe">eSIM-fähig</a> und <a href="/pages/hilfe">ohne SIM-Lock</a>.</p>';

    document.body.appendChild(bar);
    document.body.classList.add('esr-has-buybar');

    var nameBox = bar.querySelector('.esr-buybar__name');
    var totalBox = bar.querySelector('.esr-buybar__total b');
    var cta = bar.querySelector('.esr-buybar__cta');

    function currentPrice() {
      var box = document.querySelector('.product__info-container');
      if (!box) return '';
      var el = box.querySelector('.price-item--sale') || box.querySelector('.price-item--regular') || box.querySelector('.price-item');
      return el ? el.textContent.trim() : '';
    }

    function sync() {
      nameBox.textContent = name;
      var p = currentPrice();
      if (p) totalBox.textContent = p;
      cta.disabled = submit.disabled;
      cta.textContent = submit.disabled ? 'Nicht verfügbar' : 'In den Warenkorb';
    }
    sync();

    var info = document.querySelector('.product__info-container');
    if (info && window.MutationObserver) {
      new MutationObserver(sync).observe(info, { subtree: true, childList: true, characterData: true, attributes: true });
    }

    cta.addEventListener('click', function () { submit.click(); });

    bar.querySelector('.esr-buybar__details').addEventListener('click', function () {
      var t = document.querySelector('.product__accordion') || document.querySelector('.esr-pdp__box') || info;
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -120px 0px' }).observe(submit);
    } else {
      bar.classList.add('is-visible');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
